import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  // url: any = "http://localhost:4205/#/view-settings";
  url: any = "https://ogc.mapedia.co.th/lrfund-general/#/view-settings"
  iframeUrl: any;

  constructor(
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    this.setIframeUrl();
  }

  setIframeUrl() {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

}
